import * as actionTypes from "./actionTypes";
import store from "../store";
import { getTCFormData, getEntrySummaryForm } from "../api/getEntrySummaryData";
import { convertTCItems } from "../components/entrySummaryForms/util/assignValues";
import { initializeTC, initializeECCCFlag } from "./initializeValues";

export const toggleTC = (merchandiseId, lineItemIndex, pgaPayload) => ({
  type: actionTypes.TOGGLE_TC(lineItemIndex),
  payload: {
    merchandiseId,
    pgaPayload,
  },
});

export function toggleTCForm(merchandiseId, lineItemIndex, pgaPayload) {
  store.dispatch(toggleTC(merchandiseId, true, lineItemIndex, pgaPayload));
  getEntrySummaryForm(window.shipmentId)
    .then((response) => {
      store.dispatch(
        initializeECCCFlag(
          response.data.eventMessage.descriptionOfMerchandise
            .merchandiseLineItems
        )
      );

      const findTcValue =
        response.data.eventMessage.descriptionOfMerchandise
          .merchandiseLineItems[lineItemIndex].pgaDetails.pgaDetails;

      return store.dispatch(
        initializeTC(lineItemIndex, convertTCItems(findTcValue, merchandiseId))
      );
    })
    .catch((err) => {
      console.error("TC Error", err);
      let error = {
        TCError: err,
      };
      return store.dispatch(
        initializeTC(lineItemIndex, {
          error: `ERROR: Could not retrieve TC Certification for the associated HTS and Merchandise ID ${merchandiseId} ${error}`,
        })
      );
    });
}

export function updateTCField(lineItemIndex, field, payload, level) {
  return {
    type: actionTypes.UPDATE_TC_FIELD(lineItemIndex),
    payload,
    field,
    level,
  };
}
export function updateTCType(lineItemIndex, payload) {
  return {
    type: actionTypes.UPDATE_TC_TYPE(lineItemIndex),
    payload,
  };
}

export function saveTCField(merchandiseId, lineItemIndex, field, level) {
  return {
    type: actionTypes.SAVE_TC_FIELD(lineItemIndex),
    field,
    merchandiseId,
    level,
  };
}
//
// export function saveTCField(merchandiseId, lineItemIndex, field) {
//   return {
//     type: actionTypes.SAVE_PGA_FROM_DETAILS(lineItemIndex),
//     field,
//     merchandiseId
//   }
// }
